import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDocumentLock = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-document-lock';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "m3.25 11.97.01 7.73h7.24l.011-.75.011-.75H4.76V5.76h13.479l.011 1.87.01 1.87h1.48l.01-2.63.011-2.63H3.24zm4.248-3.679c-.011.029-.015.366-.009.75l.011.699 4.03.01 4.03.01V8.24h-4.021c-3.239 0-4.025.01-4.041.051m8.114 2.99a2.1 2.1 0 0 0-1.792 1.609c-.037.156-.059.457-.059.8l-.001.55h-1.52v6.52h8.52v-6.52h-1.52l-.001-.55c0-.343-.022-.644-.059-.8-.178-.753-.801-1.388-1.541-1.569-.236-.058-1.661-.086-2.027-.04m1.712 1.525c.329.11.404.273.428.924l.019.51h-2.542l.019-.51c.024-.641.1-.812.412-.922.166-.058 1.492-.06 1.664-.002M19.24 17.5v1.74h-5.48v-3.48h5.48zm-3.48 0v.74h1.48v-1.48h-1.48z"
    })
  }));
});
export default SvgDocumentLock;